module.exports = __webpack_public_path__ + "img/list1_2.71f623de.png";